<template>
	<div id="app">
		<!-- <keep-alive>
			<router-view />
		</keep-alive> -->
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive" />
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive" />
	</div>

	<!-- <div class="upgrade_box">
		<div class="upgrade_info">
			<div>服務維護中，預計1月7日 04：00完成</div>
			<div>Service maintenance is expected to be completed by 04:00 on January 7th</div>
		</div>
	</div> -->
</template>
<script>
	export default {
		name: "App",
		async mounted() {
			//获取语言设置
			const language = localStorage.getItem("language") || "en";
			console.log("语言设置", language);
			if (language) {
				// 切换语言
				this.$i18n.locale = language;
				this.$store.state.language = language;
			}
		},
	};
</script>
<style scoped lang="scss">
	.upgrade_box {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		background: rgba(0, 0, 0, 0.5);
		display: flex;

		.upgrade_info {
			width: 80%;
			height: 300px;
			border-radius: 10px;
			background: #fff;
			margin: auto;
			padding: 20px;
			display: flex;
			flex-direction: column;
			text-align: center;
			align-items: center;
			justify-content: center;
			gap: 20px;
		}
	}
</style>
<style lang="scss">
	.my_tabs > .van-tabs__wrap {
		display: none !important;
	}

	html {
		background: #fff;
		// max-width: 500px;
		margin: auto;
		overflow-x: hidden;
	}

	.van-notify {
		z-index: 99999 !important;
	}

	.van-tabbar-item__icon img {
		height: 26px !important;
	}

	// .container {
	// 	height: calc(100vh - 68px);
	// 	overflow: hidden auto;
	// }

	html,
	body,
	.container {
		scrollbar-width: none;
		-ms-overflow-style: none; /* IE 和 Edge 隐藏滚动条 */
		scrollbar-width: none;
	}
	html::-webkit-scrollbar {
		display: none;
		width: 0;
		height: 0;
	}
	body::-webkit-scrollbar {
		display: none;
		width: 0;
		height: 0;
	}
	.container::-webkit-scrollbar {
		display: none;
		width: 0;
		height: 0;
	}

	img {
		pointer-events: auto; /* 确保删除图标可以点击 */
		user-select: none; /* 防止选中 */
		-webkit-user-drag: none; /* 防止拖拽 */
	}
</style>
